import React, { useEffect, useState } from "react";
import {
  FaPlus,
  FaEllipsisVertical,
  FaEye,
  FaPen,
  FaCopy,
  FaFilter,
  FaArrowLeftLong,
} from "react-icons/fa6";
import { MdDelete, MdSearch, MdRefresh } from "react-icons/md";
import { handleRowsPerPage } from "../../../controls/Pagination/Pagination";
import { capitalizeWords } from "../../../../utils/common";
import { MOBILE_USER_ACTIVITY_LOG_DETAILS } from "../../../../navigation/routes";

import { Header, DataTable } from "../../../common";
import {
  ButtonView,
  CardView,
  Input,
  Select,
  ModalView,
  IconMenuOption,
} from "../../../controls";

import moment from "moment";
import { history } from "../../../../store/configure/configureStore";
import "./MobileUsersActivityLogStyles.scss";

const MobileUsersActivityLogView = ({
  mobileUserActivityLogs,

  //
  currentPageOfUsersActivityLog,
  rowsPerPageOfUsersActivityLog,
  //
  rowsPerPageDropDownOptions,
  //
  handleTableRowsChange,
  handleChangePage,
}) => {
  // console.log("mobileUserActivityLogs", mobileUserActivityLogs);

  const columns = [
    {
      name: "Request URL",
      // cell: (row) => renderOriginalTransactionValue(row),
      cell: (row) => row?.requestUrl || "-",
      // grow: 1.5,
      width: "60%",
    },
    {
      name: "Request Method",
      selector: (row) => row?.requestMethod || "-",
      // grow: 2,
      width: "15%",
    },
    {
      name: "Created At",
      selector: (row) =>
        moment(row?.createdAt).format("MM-DD-YYYY hh:mm A") || "-",

      // grow: 1,
      width: "15%",
    },
    {
      name: "Action",
      selector: (row) => renderActionMenu(row),
      // grow: 1,
      width: "10%",
      center: true,
    },
  ];

  const renderActionMenu = (row) => {
    const menuList = [
      {
        icon: <FaEye size={15} color="#B6C7AA" title="View" />,

        onclick: () => {
          history?.push(`${MOBILE_USER_ACTIVITY_LOG_DETAILS}/${row?._id}`);
        },
      },
    ];

    return (
      <div className="action-menu-wrapper d-flex gap-3">
        {menuList.map((item) => {
          return (
            <div className="menu-item" onClick={item?.onclick}>
              {item?.icon}
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div className="mobile__users__activity__log--container">
      <div className="mobile__users__activity__log--header-wrapper">
        <div className="action">
          <FaArrowLeftLong size={25} onClick={() => history?.goBack()} />
        </div>
        <div className="title-content">Users Activity Log</div>
        <div className="action-btn-wrapper"></div>
      </div>
      <div className="mobile__users__activity__log--table-wrapper">
        <div className="controls-wrapper">
          <div className="row-control-wrapper">
            <Select
              value={rowsPerPageOfUsersActivityLog}
              placeholder={10}
              options={rowsPerPageDropDownOptions}
              onChange={(val) => {
                handleTableRowsChange(val);
              }}
              isRowCap={true}
            />{" "}
            entries per page
          </div>
        </div>
        <div className="table-content">
          <DataTable
            keyfield={"_id"}
            columns={columns}
            data={mobileUserActivityLogs?.docs || []}
            highlightOnHover={true}
            pointerOnHover={true}
            fixedHeader={true}
            persistTableHead={true}
            //
            pagination={true}
            paginationServer={true}
            paginationPerPage={mobileUserActivityLogs?.limit}
            paginationTotalRows={mobileUserActivityLogs?.totalDocs}
            onChangeRowsPerPage={handleTableRowsChange}
            onChangePage={handleChangePage}
            currentPage={currentPageOfUsersActivityLog}
          />
        </div>
      </div>
    </div>
  );
};

export default MobileUsersActivityLogView;
